import React, { useState, useRef, useEffect } from "react";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { useForm } from "react-hook-form";
import Tooltip from "@tippyjs/react";
import { ToastContainer, toast } from "react-toastify";
import "tippy.js/dist/tippy.css";
import authHeader from "../../services/auth-header";
import { API } from "../../backend";
import axios from "axios";
import AddContractSettingService from "../../services/settings/AddContractSettingService";
import AddInvoiceSettingService from "../../services/settings/AddInvoiceSettingService";
import GetCompanyInfoService from "../../services/company/getCompanyInfoService";
import ButtonLoading from "../../components/Loder/buttonLoading";
import { getTrans as t } from "../../Localization/translations";
import AddAssetSettingService from "../../services/settings/AddAssetSettingServices";
import AddReceiptSettingService from "../../services/settings/AddReceiptSettingService";
import AddPartySettingService from "../../services/settings/AddPartySettingServices";
import AddQuoteSettingService from "../../services/settings/addquoteSettingServices";
import AddTimeoutSettingService from "../../services/settings/AddTimeSettingServices";
import AddInventorySettingService from "../../services/settings/AddInventorySettingServices";
import AddPartyRoleSettingService from "../../services/settings/AddPartyRoleSettingService";
import PartyRolesList from "./PartyRolesList"; // Assume path, adjust as needed

function EditSetting({ setInputValue }) {
  const [planFeatures, setPlanFeatures] = useState(null);
  const checkBtn = useRef();
  const checkBtn2 = useRef();
  const checkBtn3 = useRef();
  const checkBtn4 = useRef();
  const checkbtn5 = useRef()
  const checkBtn6 = useRef(); // New ref for party roles form

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const {
    register: register2,
    reset: reset2,
    formState: { errors: errors2 },
    handleSubmit: handleSubmit2,
  } = useForm();
  const {
    register: register4,
    reset: reset4,
    formState: { errors: errors4 },
    handleSubmit: handleSubmit4,
  } = useForm();
  const {
    register: register6, // New register for party roles form
    reset: reset6,
    formState: { errors: errors6 },
    handleSubmit: handleSubmit6,
  } = useForm();
  const [disable_automaticvalue, setDisable_Automaticvalue] = useState("");
  // const [manual, setManual] = useState(false);
  const [prefix, setPrefix] = useState("");
  const [number, setNumber] = useState("");
  const [suffixnumber, setSuffixNumber] = useState("");
  const [invoiceseries, setInvoiceSeries] = useState("");
  const [quote_number, setQuote_Number] = useState("");
  const [exiprydays, setExpiry_Days] = useState("");
  const [pastduebucket, setPastDueBucket] = useState("");
  const [invoice_template, setInvoiceTemplate] = useState("");
  const [partyseries, setPartySeries] = useState("");
  const [address_series, setAddress_Series] = useState("");
  const [assetseries, setAssetSeries] = useState("");
  const [inventoryseries, setInventorySeries] = useState("");
  const [receiptseries, setReceiptSeries] = useState("");
  const [loading, setLoading] = useState(false);
  const [invoiceloading, setInvoiceLoading] = useState(false);
  const [quotetionloading, setQuotetionLoading] = useState(false);
  const [partyloading, setPartyLoading] = useState(false);
  const [assetloading, setAssetLoading] = useState(false);
  const [inventoryLoading, setInventoryLoading] = useState(false)
  const [receiptloading, setReceiptLoading] = useState(false);
  const [timeoutLoading, setTimeoutLoading] = useState(false)
  const [time_out, setTime_out] = useState(0)
  const [assettype, setAssettype] = useState([]);
  const [taxrate_setup, setTaxRate_Setup] = useState("");

  const [partyRoles, setPartyRoles] = useState([]); // New state for party roles
  const [newRole, setNewRole] = useState(""); // State for adding new role
  const [partyRoleLoading, setPartyRoleLoading] = useState(false); // New loading state for party roles
  const [editedRole, setEditedRole] = useState(null);

  const [incomeBasis, setIncomeBasis] = useState("");
  const [basisLoading, setBasisLoading] = useState(false);


  // const [taxrateloading, setTaxRateLoading] = useState(false);
  const [error, setError] = useState('');
  const form = useRef();
  const form2 = useRef();
  const form3 = useRef();
  const form4 = useRef();
  const form5 = useRef()
  const form6 = useRef(); // New ref for party roles form

  const handleContract = () => {
    setLoading(true);
    form2.current.validateAll();
    if (checkBtn2.current.context._errors.length === 0) {
      let contract_number_method = { disable_automaticvalue }
        ? "Automatic"
        : "Manual";
      if ((contract_number_method = disable_automaticvalue === "Automatic")) {
        contract_number_method = "Automatic";
      } else {
        contract_number_method = "Manual";
      }
      AddContractSettingService.addContractSetting(
        contract_number_method,
        prefix,
        number,
        suffixnumber
      ).then((response) => {
        if (response.data.success) {
          setLoading(false);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

        } else {
          setLoading(false);
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
    }
  };

  const handlePartyRoles = () => {
    setPartyRoleLoading(true);
    form6.current.validateAll();

    if (checkBtn6.current.context._errors.length === 0) {
      const roleNames = partyRoles
        .filter(role => role.isChecked)
        .map(role => role.name.trim())
        .join(", ");

      AddPartyRoleSettingService.addPartyRoleSetting(roleNames)
        .then((response) => {
          if (response.data.success) {
            toast.success(response.data.response, { autoClose: 1000 });
          } else {
            toast.error(response.data.error, { autoClose: 1000 });
          }
          setPartyRoleLoading(false);
        })
        .catch(() => setPartyRoleLoading(false));
    } else {
      setPartyRoleLoading(false);
    }
  };

  const handleAddRole = () => {
    const trimmedRole = newRole.trim();

    if (
      trimmedRole &&
      !partyRoles.some(r => r.name.toLowerCase() === trimmedRole.toLowerCase())
    ) {
      setPartyRoles([
        ...partyRoles,
        { name: trimmedRole, originalName: trimmedRole, isChecked: true }
      ]);
      setNewRole("");
      // if you want to reset RHF fields, use the correct key:
      reset6({ newRole: "" });
    }
    else if (partyRoles.some(r => r.name.toLowerCase() === trimmedRole.toLowerCase())) {
      toast.error("Role already exists", { autoClose: 1000 });
    }
  };


  const handleEditRole = (index, value) => {
    const updatedRoles = [...partyRoles];
    updatedRoles[index] = value;
    setPartyRoles(updatedRoles);
  };

  //   const handleRenameRole = (index, newName) => {
  //   const trimmedName = newName.trim();
  //   if (
  //     trimmedName &&
  //     !partyRoles.some((role, i) => i !== index && role.name.toLowerCase() === trimmedName.toLowerCase())
  //   ) {
  //     setPartyRoles(prev =>
  //       prev.map((role, i) =>
  //         i === index ? { ...role, name: trimmedName } : role
  //       )
  //     );
  //   } else {
  //     toast.error("A role with this name already exists", { autoClose: 1000 });
  //   }
  // };

  const handleRenameRole = (index, newName) => {
    const trimmedName = newName.trim();

    if (!trimmedName) {
      toast.error("Role name cannot be empty", { autoClose: 1000 });
      return;
    }

    if (partyRoles.some((role, i) => i !== index && role.name.toLowerCase() === trimmedName.toLowerCase())) {
      toast.error("A role with this name already exists", { autoClose: 1000 });
      return;
    }

    setPartyRoles(prev =>
      prev.map((role, i) =>
        i === index ? { ...role, name: trimmedName } : role
      )
    );
  };

  const handleDeleteRole = (index) => {
    const updatedRoles = partyRoles.filter((_, i) => i !== index);
    setPartyRoles(updatedRoles);
  };
  //  const handleToggleRole = (role) => {
  //   if (partyRoles.includes(role)) {
  //     setPartyRoles(partyRoles.filter((r) => r !== role));
  //   } else {
  //     setPartyRoles([...partyRoles, role]);
  //   }
  // };
  const handleToggleRole = (index) => {
    setPartyRoles(prev =>
      prev.map((role, i) =>
        i === index ? { ...role, isChecked: !role.isChecked } : role
      )
    );
  };

useEffect(() => {
  const fetchSubscriptionFeatures = async () => {
    try {
      const response = await axios.get(`${API}paymentsub/subscription/`, {
      headers: authHeader()
      });
                
      if (response.data.success === 1 && response.data.data) {
        setPlanFeatures(response.data.data.plan);
      }
      } catch (error) {
          console.error("Error fetching subscription features:", error);
      }
      };
      fetchSubscriptionFeatures();
      }, []);
      const isCashDisabled = planFeatures !== null && planFeatures.cash_basis_revenue === false;

  useEffect(() => {
    axios
      .get(API + "accounting/update-income-basis/", {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.data.success === 1) {
          setIncomeBasis(res.data.basis);
        }
      });
  }, []);





  useEffect(() => {
    GetCompanyInfoService.getCompanySettingInfo().then((response) => {
      setPrefix(response.data.contract_number_prefix);
      setInvoiceSeries(response.data.invoice_series);
      setPastDueBucket(response.data.invoice_past_due_bucket);
      setPartySeries(response.data.party_series);
      setAddress_Series(response.data.address_series);
      setInventorySeries(response.data.inventory_series);
      setInvoiceTemplate(response.data.invoice_template);
      setAssetSeries(response.data.asset_series);
      setReceiptSeries(response.data.receipt_series);
      setSuffixNumber(response.data.contract_number_suffix);
      setNumber(response.data.contract_number_number);
      setExpiry_Days(response.data.contract_no_of_days);
      setQuote_Number(response.data.contract_quote_number);
      setTaxRate_Setup(response.data.tax_setup);
      setNumber(response.data.contract_number_number);
      setTime_out(response.data.timeout);
      setInputValue(response.data.timeout * 60 * 1000)
      setAssettype(response.data.assets_type.split(", "));
      setDisable_Automaticvalue(response.data.contract_number_method);
      // setPartyRoles(response.data.party_roles ? response.data.party_roles.split(", ") : ["Guarantor", "Insurance Provider", "Private Label Holder"]);
      //    const rolesString = response.data.party_roles;
      // const initialRoles = rolesString
      //   ? rolesString.split(",").map(role => ({
      //       name: role.trim(),
      //       originalName: role.trim(),
      //       isChecked: true
      //     }))
      //   : [
      //       { name: "Guarantor", originalName: "Guarantor", isChecked: true },
      //       { name: "Insurance Provider", originalName: "Insurance Provider", isChecked: true },
      //       { name: "Private Label Holder", originalName: "Private Label Holder", isChecked: true }
      //     ];

      //   setPartyRoles(initialRoles);
      reset2({
        number: response.data.contract_number_number,
      });
    })
  }, []);

  const handleInvoice = () => {
    setInvoiceLoading(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      AddInvoiceSettingService.addInvoiceSetting(invoiceseries, pastduebucket, invoice_template).then(
        (response) => {
          if (response.data.success) {
            setInvoiceLoading(false);
            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else {
            setInvoiceLoading(false);
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        }
      )
    }
  };

  const handleTimeout = () => {
    setInputValue(time_out * 60 * 1000)
    setTimeoutLoading(true);
    form5.current.validateAll();
    if (checkbtn5.current.context._errors.length === 0) {
      AddTimeoutSettingService.addTimeoutSetting(time_out).then(
        (response) => {
          if (response.data.success) {
            setTimeoutLoading(false);
            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });

          } else {
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setTimeoutLoading(false);

          }
        }
      )
    }
  }

  const handleIncomeBasis = async () => {
    try {
      setBasisLoading(true);

      await axios.post(
        API + "accounting/update-income-basis/",
        { basis: incomeBasis },
        { headers: authHeader() }
      );

      toast.success("Income Recognition Basis updated successfully.");
      setBasisLoading(false);

    } catch (error) {
      setBasisLoading(false);
      toast.error("Something went wrong.");
    }
  };



  const handleChange = (e) => {
    const value = e.target.value === '' ? '' : parseInt(e.target.value, 10);
    setTime_out(value);
    if (isNaN(value) || value < 5) {
      setError('Minimum 5 minutes is required');
    } else {
      setError('');
    }
  };

  const handleQuote = () => {
    setQuotetionLoading(true);
    form3.current.validateAll();
    if (checkBtn3.current.context._errors.length === 0) {
      AddQuoteSettingService.addQuoteSetting(quote_number, exiprydays).then(
        (response) => {
          if (response.data.success) {
            setQuotetionLoading(false);
            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else {
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setQuotetionLoading(false);
          }
        }
      )
    }
  };

  // const handleTaxRateSetup = () => {   // for Tax Rate Setup 
  //   setTaxRateLoading(true);
  //   form4.current.validateAll();
  //   if (checkBtn4.current.context._errors.length === 0) {
  //     AddTaxSetup.addTaxSetup(taxrate_setup).then(
  //       (response) => {
  //         if (response.data.success) {
  //           setTaxRateLoading(false);
  //           toast.success(`${response.data.response}`, {
  //             position: "top-right",
  //             autoClose: 1000,
  //             hideProgressBar: false,
  //             pauseOnHover: true,
  //             draggable: true,
  //             progress: undefined,
  //             theme: "light",
  //           });
  //         } else {
  //           toast.error(`${response.data.error}`, {
  //             position: "top-right",
  //             autoClose: 1000,
  //             hideProgressBar: false,
  //             pauseOnHover: true,
  //             draggable: true,
  //             progress: undefined,
  //             theme: "light",
  //           });
  //           setTaxRateLoading(false);
  //         }
  //       }
  //     );
  //   }
  // };

  const handleParty = () => {
    setPartyLoading(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      AddPartySettingService.addPartySetting(partyseries, address_series).then(
        (response) => {
          if (response.data.success) {
            setPartyLoading(false);
            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else {
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setPartyLoading(false);
          }
        }
      )
    }
  };

  const handleAsset = () => {
    setAssetLoading(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      AddAssetSettingService.addAssetSetting(
        assetseries,
        assettype.join(", ")
      ).then((response) => {
        if (response.data.success) {
          setAssetLoading(false);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setAssetLoading(false);
        }
      })
    }
  };

  const handleInventory = () => {
    setInventoryLoading(true)
    form4.current.validateAll();
    if (checkBtn4.current.context._errors.length === 0) {
      let inventory_series = inventoryseries
      AddInventorySettingService.addInventorySetting(inventory_series).then(
        (response) => {
          if (response.data.success) {
            setInventoryLoading(false);
            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else {
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setInventoryLoading(false);
          }
        }
      )
    }

  }
  const handleReceipt = () => {
    setReceiptLoading(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      AddReceiptSettingService.addReceiptSetting(receiptseries).then(
        (response) => {
          if (response.data.success) {
            setReceiptLoading(false);
            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else {
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setReceiptLoading(false);
          }
        }
      )
    }
  };

  const handleAssettypeCheckbox = (e) => {
    const { value } = e.target;
    const updatedValues = [...assettype];

    if (e.target.checked) {
      updatedValues.push(value);
    } else {
      const index = updatedValues.indexOf(value);
      if (index > -1) {
        updatedValues.splice(index, 1);
      }
    }

    setAssettype(updatedValues);
  };

  const TaxRateSetup = (e) => {
    setTaxRate_Setup(e.target.value)
  }

  const getTemplateImage = (template) => {
    switch (template) {
      case '1':
        return `${process.env.PUBLIC_URL}/static/assets/img/curved-images/NewLeft.png`;
      case '2':
        return `${process.env.PUBLIC_URL}/static/assets/img/curved-images/NewRight.png`;
      case '3':
        return `${process.env.PUBLIC_URL}/static/assets/img/curved-images/NewCenter.png`;
      default:
        return '';
    }
  };


  const [achprovider, setAchprovider] = useState({
    immediateDestination: "",
    immediateDestinationName: "",
    immediateOrigin: "",
    immediateOriginName: "",
    companyIdentification: "",
    standardEntryClassCode: "",
    originatingBankFID: "",
    originatorTaxID: "",
    achOperatorName: "",
    destination: "",
    destinationName: "",
    serviceClassCode: "",
  });

  const achChange = (e) => {
    const { name, value } = e.target;
    setAchprovider((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const [showPartyRoles, setShowPartyRoles] = useState(false); // New state for showing PartyRolesList
  if (showPartyRoles) {
    return <PartyRolesList onBack={() => setShowPartyRoles(false)} />;
  }



  return (
    <>
      <div className="">
        <ToastContainer />
        <div className="header pb-0" style={{ marginLeft: '15px' }}>
          <div className="d-lg-flex">
            <div>
              <h5 className="mb-3">{t("Global Setting")}</h5>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="" style={{ marginLeft: '15px' }}>
        <div className="row">
          <div className="col-md-8">
            <h5 className="mt-3 mb-3">{t("Contract Setting")}</h5>
            <div className="card mb-4">
              <div className="card-body">
                <Form
                  role="form text-left"
                  onSubmit={handleSubmit2(handleContract)}
                  ref={form2}
                  key={2}
                  action="."
                  method="POST"
                  id="addReceiptForm"
                >
                  {
                    <>
                      <div className="col-xl-6 mt-3">
                        <label className="col-form-label ">
                          {t("Contract Numbering")}{" "}
                          <Tooltip
                            content={t("ContractNumbersetting_Tooltip")}
                          >
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                      </div>
                      <div className="row">
                        <div
                          className="form-check"
                          style={{ width: "50%", paddingLeft: "2.73em" }}
                        >
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={
                              disable_automaticvalue === "Automatic"
                                ? true
                                : false
                            }
                            value="Automatic"
                            onChange={(e) =>
                              setDisable_Automaticvalue(e.target.value)
                            }
                            id="Automatic"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault1"
                          >
                            {t("Automatic")}
                          </label>
                        </div>
                        <div
                          className="form-check"
                          style={{ width: "25%", paddingLeft: "3.0em" }}
                        >
                          <input
                            className="form-check-input"
                            disabled={
                              disable_automaticvalue === "Automatic"
                                ? true
                                : false
                            }
                            onChange={(e) =>
                              setDisable_Automaticvalue(e.target.value)
                            }
                            checked={
                              disable_automaticvalue === "Manual"
                                ? true
                                : false
                            }
                            type="checkbox"
                            value="Manual"
                            name="Manual"
                            id="overide_application"
                          />
                          <label
                            className={
                              disable_automaticvalue === "Automatic"
                                ? "form-check-label  font-weight-bold"
                                : "form-check-label"
                            }
                            htmlFor="flexRadioDefault2"
                          >
                            {t("Manual")}
                          </label>
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-lg-6">
                          <label className=" col-form-label">
                            {t("Prefix")}{" "}
                            <Tooltip content={t("Prefixsetting_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <div className="col-lg-12">
                            <input
                              placeholder={t("Ex. ABC")}
                              className="form-control"
                              type="text"
                              value={prefix}
                              disabled={
                                disable_automaticvalue === "Automatic"
                                  ? false
                                  : true
                              }
                              name="prefix"
                              id="Prefix"
                              {...register2("prefix", {
                                onChange: (e) => {
                                  setPrefix(e.target.value);
                                },
                                required: false,
                                pattern: {
                                  value:
                                    /^[a-zA-Z\u00C0-\u017F]+(?:\s[a-zA-Z\u00C0-\u017F]+)*$/,
                                  message: "Please enter a valid Prefix",
                                },
                              })}
                            />
                            <div className="invalid-feedback">
                              {errors2.prefix?.message}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <label className=" col-form-label">
                            {t("Number")}{" "}
                            <Tooltip content={t("Numbersetting_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <div className="col-lg-12">
                            <input
                              className="form-control"
                              placeholder={t("Ex. 10000")}
                              type="number"
                              value={number}
                              disabled={
                                disable_automaticvalue === "Automatic"
                                  ? false
                                  : true
                              }
                              name="number"
                              {...register2("number", {
                                onChange: (e) => {
                                  setNumber(e.target.value);
                                },
                                required:
                                  disable_automaticvalue === "Automatic"
                                    ? true
                                    : false,
                              })}
                            />
                            <div className="invalid-feedback">
                              {errors2.number?.type === "required" &&
                                "Number is required"}
                            </div>
                          </div>
                        </div>
                      </div>
                      <label className="col-lg-12 col-form-label">
                        {t("Suffix Number")}{" "}
                        <Tooltip content={t("Suffixnumber_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <div className="col-lg-6">
                        <input
                          placeholder={t("Ex. XYZ")}
                          className="form-control"
                          type="text"
                          value={suffixnumber}
                          disabled={
                            disable_automaticvalue === "Automatic"
                              ? false
                              : true
                          }
                          name="suffixnumber"
                          id="suffixnumber"
                          {...register2("suffixnumber", {
                            onChange: (e) => {
                              setSuffixNumber(e.target.value);
                            },
                            required: false,
                            pattern: {
                              value:
                                /^[a-zA-Z\u00C0-\u017F]+(?:\s[a-zA-Z\u00C0-\u017F]+)*$/,
                              message: "Please enter a valid Suffix Number",
                            },
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors2.suffixnumber?.message}
                        </div>
                      </div>
                      <div className="text-left py-3 pt-4">
                        <button
                          type="submit"
                          className="btn-save border-0 btn btn-primary btn-gradient-primary btn-md"
                        >
                          {loading === false ? t("Save") : <ButtonLoading />}
                        </button>
                        &nbsp;&nbsp;
                      </div>
                    </>
                  }
                  <CheckButton style={{ display: "none" }} ref={checkBtn2} />
                </Form>
              </div>
            </div>
            {/* Party Roles Setting Section - Replaced with button */}
            {/* <div className="">
              <div className="" style={{ marginLeft: '15px' }}>
                <div>
                  <b>
                    <h5 className="mt-3 mb-3">{t("Party Roles Setting")}</h5>
                  </b>
                </div>
              </div>
              <div className="card" style={{ marginLeft: '15px' }}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="card-body">
                      <button
                        className="btn-save border-0 btn btn-primary btn-gradient-primary btn-md"
                        onClick={() => setShowPartyRoles(true)}
                      >
                        {t("Manage Party Roles")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
          <div className="col-md-4">
            <h5 className="mt-3 mb-3">{t("Timeout Setting")}</h5>
            <div className="card mb-4">
              <div className="card-body">
                <Form
                  role="form text-left"
                  onSubmit={handleSubmit(handleTimeout)}
                  ref={form5}
                  action="."
                  method="POST"
                  id="addTimeoutForm"
                >
                  <>
                    <div className="form-group row">
                      <div className="col-lg-6">
                        <div className="d-flex align-items-center">
                          <input
                            value={time_out}
                            className={`form-control no-spinner ${error ? 'is-invalid' : ''}`}
                            style={{ maxWidth: '100px' }}
                            type="number"
                            onChange={handleChange}
                            name="timeout"
                            id="timeout"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault1"
                          >
                            Minutes

                          </label>
                        </div>
                        {error && (
                          <div className="invalid-feedback" style={{ display: 'block' }}>
                            {error}
                          </div>
                        )}
                      </div>
                      <div className="text-left py-3">
                        <button
                          type="submit"
                          className="btn-save border-0 btn btn-primary btn-gradient-primary btn-md"
                        >
                          {timeoutLoading === false ? (
                            t("Save")
                          ) : (
                            <ButtonLoading />
                          )}
                        </button>
                        &nbsp;&nbsp;
                      </div>
                    </div>
                  </>
                  <CheckButton style={{ display: "none" }} ref={checkbtn5} />
                </Form>
              </div>
            </div>
            {/* Income Recognition Basis */}
            <h5 className="mt-3 mb-3">{t("Income Recognition Basis")}</h5>
            <div className="card mb-4">
              <div className="card-body">
                <Form
                  role="form text-left"
                  onSubmit={handleSubmit(handleIncomeBasis)}
                  action="."
                  method="POST"
                  id="incomeBasisForm"
                >
                  <>
                    <div className="form-group row">
                      <div className="col-lg-12">

                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="incomeBasis"
                            id="basisAccrual"
                            value="Accrual"
                            checked={incomeBasis === "Accrual"}
                            onChange={(e) => setIncomeBasis(e.target.value)}
                          />
                          <label className="form-check-label" htmlFor="basisAccrual">
                            Accrual
                          </label>
                        </div>

                        <div className="form-check mt-2"
                        className="form-check mt-2"
                        style={{ 
                          opacity: isCashDisabled ? 0.6 : 1, 
                          cursor: isCashDisabled ? 'not-allowed' : 'default' 
                        }}
                        >
                          <input
                            className="form-check-input"
                            type="radio"
                            name="incomeBasis"
                            id="basisCash"
                            value="Cash"
                            checked={incomeBasis === "Cash"}
                            disabled={isCashDisabled}
                            onChange={(e) => setIncomeBasis(e.target.value)}
                            style={{ cursor: isCashDisabled ? 'not-allowed' : 'pointer' }}
                          />
                          <label className="form-check-label" htmlFor="basisCash"
                          style={{ color: isCashDisabled ? '#9E9E9E' : 'inherit' }}
                          >
                            Cash {isCashDisabled && <span title="Premium Feature">🔒</span>}
                          </label>
                        </div>

                      </div>

                      <div className="text-left py-3">
                        <button
                          type="submit"
                          className="btn-save border-0 btn btn-primary btn-gradient-primary btn-md"
                        >
                          {basisLoading === false ? (
                            t("Save")
                          ) : (
                            <ButtonLoading />
                          )}
                        </button>
                      </div>
                    </div>
                  </>
                </Form>
              </div>
            </div>

          </div>

        </div>

      </div>
      <div className="">
        <div className="" style={{ marginLeft: '15px' }}>
          <div>
            <b>
              <h5 className="mt-3 mb-3">{t("Quotation Setting")}</h5>
            </b>
          </div>
        </div>
        <div className="card" style={{ marginLeft: '15px' }}>
          <div className="row">
            <div className="col-md-12">
              <div className="card-body">
                <Form
                  role="form text-left"
                  onSubmit={handleSubmit(handleQuote)}
                  ref={form3}
                  action="."
                  method="POST"
                >
                  {
                    <>
                      <div className="form-group row">
                        <div className="col-md-6"></div>
                      </div>
                      <div className="form-group row">
                        <div className="col-lg-6">
                          <label className="col-lg-12 col-form-label required">
                            {t("Payoff Quote Number Starts From")}{" "}
                            <Tooltip content={t("QuoteNumber_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <div className="col-lg-6">
                            <input
                              value={quote_number}
                              placeholder={t("Ex. 10000")}
                              className="form-control no-spinner"
                              type="number"
                              onChange={(e) => setQuote_Number(e.target.value)}
                              name="quotation_number"
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <label className="col-lg-12 col-form-label required">
                            {t("Payoff Quote Validity Days")}{" "}
                            <Tooltip content={t("Noofdays_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <div className="col-lg-6">
                            <input
                              value={exiprydays}
                              placeholder={t("No of Days")}
                              className="form-control no-spinner"
                              type="number"
                              onChange={(e) => setExpiry_Days(e.target.value)}
                              name="expirydays"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="text-left py-3">
                        <button
                          type="submit"
                          className="btn-save border-0 btn btn-primary btn-gradient-primary btn-md"
                        >
                          {quotetionloading === false ? (
                            t("Save")
                          ) : (
                            <ButtonLoading />
                          )}
                        </button>
                        &nbsp;&nbsp;
                      </div>
                    </>
                  }
                  <CheckButton style={{ display: "none" }} ref={checkBtn3} />
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* party Role settings */}

      {/* <div className="">
        <div className="" style={{ marginLeft: '15px' }}>
          <div>
            <b>
              <h5 className="mt-3 mb-3">{t("Party Roles Setting")}</h5>
            </b>
          </div>
        </div>
        <div className="card" style={{ marginLeft: '15px' }}>
          <div className="row">
            <div className="col-md-12">
              <div className="card-body">
                 <Form
                  role="form text-left"
                  onSubmit={handleSubmit6(handlePartyRoles)}
                  ref={form6}
                  action="."
                  method="POST"
                  id="addPartyRolesForm"
                >
                  <>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-lg-12 col-form-label required">
                          {t("Party Roles")}{" "}
                          <Tooltip content={t("PartyRoles_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-lg-12">
                          {partyRoles.map((role, index) => (
  <div key={index} className="d-flex align-items-center mb-2"> */}
      {/* <input
      type="checkbox"
      className="form-check-input me-2"
      checked={role.isChecked}
      onChange={() => handleToggleRole(index)}
    /> */}
      {/* <input
      type="text"
      className="form-control me-2"
      value={role.name}
      onChange={(e) => handleRenameRole(index, e.target.value)}
    />
    <button
      type="button"
      className="btn btn-danger btn-sm"
      onClick={() => handleDeleteRole(index)}
    >
      Delete
    </button>
  </div>
))}
                          <div className="d-flex align-items-center mt-2">
                           <input
                              className="form-control me-2"
                              type="text"
                              value={newRole}
                              placeholder={t("Enter new role")}
                              onChange={(e) => {
                                // optional: restrict to letters + spaces
                                const v = e.target.value;
                                if (/^[a-zA-Z\s]*$/.test(v)) setNewRole(v);
                              }}
                            />
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              onClick={handleAddRole}
                              disabled={
                                !newRole.trim() ||
                                partyRoles.some(r => r.name.toLowerCase() === newRole.trim().toLowerCase())
                              }
                            >
                              Add Role
                            </button>
                            <div className="invalid-feedback">{errors6.newRole?.message}</div>
                          </div>
                        </div>
                      </div>
                      <div className="text-left py-3">
                        <button
                          type="submit"
                          className="btn-save border-0 btn btn-primary btn-gradient-primary btn-md"
                        >
                          {partyRoleLoading === false ? t("Save") : <ButtonLoading />}
                        </button>
                        &nbsp;&nbsp;
                      </div>
                    </div>
                  </>
                  <CheckButton style={{ display: "none" }} ref={checkBtn6} />
                </Form>
                </div>
              </div>
            </div>
            </div>
            </div> */}

      <div className="">
        <div className="">
          <div style={{ marginLeft: '15px' }}>
            <b>
              <h5 className="mt-3 mb-3">{t("Invoice Setting")}</h5>
            </b>
          </div>
        </div>
        <div className="card" style={{ marginLeft: '15px' }}>
          <div className="row">
            <div className="col-md-12">
              <div className="card-body">
                <Form
                  role="form text-left"
                  onSubmit={handleSubmit(handleInvoice)}
                  ref={form}
                  action="."
                  method="POST"
                  id="addReceiptForm"
                >
                  {
                    <>
                      <div className="form-group row">
                        <div className="col-md-6">

                          {/* </div> */}

                          <label className="col-lg-12 col-form-label required">
                            {t("Invoice Number Starts From")}{" "}
                            <Tooltip content={t("StartingSeriesofInvoice_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <div className="col-lg-6">
                            <input
                              value={invoiceseries}
                              placeholder={t("Ex. 10000")}
                              className="form-control no-spinner"
                              type="number"
                              onChange={(e) => setInvoiceSeries(e.target.value)}
                              name="startingseriesofcontract"
                              id="startingseriesofcontract"
                            />
                          </div>
                        </div>
                        {/* <div className="col-md-6">
                      <label className="col-lg-12 col-form-label required">
                        {t("Past Due Buckets")}{" "}
                        <Tooltip content={t("PastDueBuckets_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <div className="col-lg-6">
                        <select
                          value={pastduebucket}
                          placeholder={t("Select past due bucket")}
                          className="form-control"
                          type="text"
                          onChange={(e) => setPastDueBucket(e.target.value)}
                          name="pastduebucket"
                          id="pastduebucket"
                          >
                            <option value=''>Select past due bucket</option>
                            <option value='30'>30</option>
                            <option value='60'>60</option>
                            <option value='90'>90</option>
                            </select>
                      </div>

                      </div>     */}
                        <div className="col-md-6 mt-3">
                          <label className="col-lg-12 col-form-label required">
                            {t("Invoice Template")}{" "}
                            <Tooltip content={t("invoicetemplate_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <div className="col-lg-6">
                            <select
                              value={invoice_template}
                              placeholder={t("Select invoice template")}
                              className="form-control"
                              type="text"
                              onChange={(e) => setInvoiceTemplate(e.target.value)}
                              name="invoicetemplate"
                              id="invoicetemplate"
                            >
                              {/* <option value=''>Select invoice template</option> */}
                              <option value='3'>Center Aligned</option>
                              <option value='1'>Left Aligned</option>
                              <option value='2'>Right Aligned</option>

                            </select>
                          </div>
                          {invoice_template && (
                            <div className="col-lg-6 mt-2">
                              <a
                                href={getTemplateImage(invoice_template)}
                                target="_blank"
                                rel="noopener noreferrer"
                                download={`invoice_template_${invoice_template === '3' ? 'Center' : invoice_template === '2' ? 'Right' : 'Left'}.png`} // Add the download attribute here
                              >
                                Preview {invoice_template === '1' ? 'left' : invoice_template === '2' ? 'Right' : 'Center'} aligned template
                              </a>
                            </div>
                          )}
                        </div>
                        <div className="text-left py-3">
                          <button
                            type="submit"
                            className="btn-save border-0 btn btn-primary btn-gradient-primary btn-md"
                          >
                            {invoiceloading === false ? (
                              t("Save")
                            ) : (
                              <ButtonLoading />
                            )}
                          </button>
                          &nbsp;&nbsp;
                        </div>
                      </div>
                    </>
                  }
                  <CheckButton style={{ display: "none" }} ref={checkBtn} />
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <div className="" style={{ marginLeft: '15px' }}>
          <div>
            <b>
              <h5 className="mt-3 mb-3">{t("Party Setting")}</h5>
            </b>
          </div>
        </div>
        <div className="card" style={{ marginLeft: '15px' }}>
          <div className="row">
            <div className="col-md-12">
              <div className="card-body">
                <Form
                  role="form text-left"
                  onSubmit={handleSubmit(handleParty)}
                  ref={form}
                  action="."
                  method="POST"
                  id="addReceiptForm"
                >
                  {
                    <>
                      <div className="form-group row">
                        <div className="col-md-6">
                          <label className="col-lg-12 col-form-label required">
                            {t("Party Number Starts From")}{" "}
                            <Tooltip
                              content={t("StartingSeriesofParty_Tooltip")}
                            >
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <div className="col-lg-6">
                            <input
                              value={partyseries}
                              placeholder={t("Ex. 10000")}
                              className="form-control no-spinner"
                              type="number"
                              onChange={(e) => setPartySeries(e.target.value)}
                              name="startingseriesofcontract"
                              id="startingseriesofcontract"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label className="col-lg-12 col-form-label required">
                            {t("Party Address Number Starts From")}{" "}
                            <Tooltip
                              content={t("StartingSeriesofAddress_Tooltip")}
                            >
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <div className="col-lg-6">
                            <input
                              value={address_series}
                              placeholder={t("Ex. 10000")}
                              className="form-control no-spinner"
                              type="number"
                              onChange={(e) =>
                                setAddress_Series(e.target.value)
                              }
                              name="startingseriesofadderess"
                              id="startingseriesofadderess"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="text-left py-3">
                        <button
                          type="submit"
                          className="btn-save border-0 btn btn-primary btn-gradient-primary btn-md"
                        >
                          {partyloading === false ? (
                            t("Save")
                          ) : (
                            <ButtonLoading />
                          )}
                        </button>
                        &nbsp;&nbsp;
                      </div>
                    </>
                  }
                  <CheckButton style={{ display: "none" }} ref={checkBtn} />
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <div className="" style={{ marginLeft: '15px' }}>
          <div>
            <b>
              <h5 className="mt-3 mb-3">{t("Inventory Setting")}</h5>
            </b>
          </div>
        </div>
        <div className="card" style={{ marginLeft: '15px' }}>
          <div className="row">
            <div className="col-md-12">
              <div className="card-body">
                <Form
                  role="form text-left"
                  onSubmit={handleSubmit4(handleInventory)}
                  ref={form4}
                  action="."
                  method="POST"
                  id="addInventoryForm"
                >
                  {
                    <>
                      <div className="form-group row">
                        <div className="col-md-6"></div>
                      </div>
                      <label className="col-lg-12 col-form-label required">
                        {t("Inventory Item Number Starts From")}{" "}
                        <Tooltip content={t("StartingSeriesofInventory_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <div className="col-lg-6">
                        <input
                          value={inventoryseries}
                          placeholder={t("Ex. 10000")}
                          className="form-control no-spinner"
                          type="number"
                          onChange={(e) => setInventorySeries(e.target.value)}
                          name="startingseriesofcontract"
                          id="startingseriesofcontract"
                        />
                      </div>
                      <div className="text-left py-3">
                        <button
                          type="submit"
                          className="btn-save border-0 btn btn-primary btn-gradient-primary btn-md"
                        >
                          {inventoryLoading === false ? (
                            t("Save")
                          ) : (
                            <ButtonLoading />
                          )}
                        </button>
                        &nbsp;&nbsp;
                      </div>
                    </>
                  }
                  <CheckButton style={{ display: "none" }} ref={checkBtn4} />
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <div className="" style={{ marginLeft: '15px' }}>
          <div>
            <b>
              <h5 className="mt-3 mb-3">{t("Asset Setting")}</h5>
            </b>
          </div>
        </div>
        <div className="card" style={{ marginLeft: '15px' }}>
          <div className="row">
            <div className="col-md-12">
              <div className="card-body">
                <Form
                  role="form text-left"
                  onSubmit={handleSubmit(handleAsset)}
                  ref={form}
                  action="."
                  method="POST"
                  id="addReceiptForm"
                >
                  {
                    <>
                      <div className="form-group row">
                        <div className="col-md-6"></div>
                      </div>
                      <label className="col-lg-12 col-form-label required">
                        {t("Asset Number Starts From")}{" "}
                        <Tooltip content={t("StartingSeriesofAsset_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <div className="col-lg-6">
                        <input
                          value={assetseries}
                          placeholder={t("Ex. 10000")}
                          className="form-control no-spinner"
                          type="number"
                          onChange={(e) => setAssetSeries(e.target.value)}
                          name="startingseriesofcontract"
                          id="startingseriesofcontract"
                        />
                      </div>
                      <div className="col-xl-6 mt-3">
                        <label className="col-form-label required">
                          {t("Asset Type to Use")}{" "}
                          <Tooltip content={t("Assettype_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                      </div>
                      <div className="row">
                        <div
                          className="form-check"
                          style={{ width: "25%", paddingLeft: "2.73em" }}
                        >
                          <input
                            className="form-check-input"
                            value="Vehicle"
                            type="checkbox"
                            name="Vehicle"
                            id="flexRadioDefault1"
                            checked={assettype.includes("Vehicle")}
                            {...register("assettype", {
                              onChange: (e, value) => {
                                handleAssettypeCheckbox(e);
                              },
                              required: false,
                            })}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault1"
                          >
                            Vehicle
                          </label>
                        </div>
                        <div
                          className="form-check"
                          style={{ width: "25%", paddingLeft: "3.0em" }}
                        >
                          <input
                            className="form-check-input"
                            value="Equipment"
                            type="checkbox"
                            name="Equipment"
                            id="flexRadioDefault2"
                            checked={assettype.includes("Equipment")}
                            {...register("assettype", {
                              onChange: (e, value) => {
                                handleAssettypeCheckbox(e);
                              },
                              required: false,
                            })}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault2"
                          >
                            Equipment
                          </label>
                        </div>
                        <div className="invalid-feedback">
                          {errors.assettype?.type === "required" &&
                            "Asset Type  is required"}
                        </div>
                      </div>
                      <div className="text-left py-3">
                        <button
                          type="submit"
                          className="btn-save border-0 btn btn-primary btn-gradient-primary btn-md"
                        >
                          {assetloading === false ? (
                            t("Save")
                          ) : (
                            <ButtonLoading />
                          )}
                        </button>
                        &nbsp;&nbsp;
                      </div>
                    </>
                  }
                  <CheckButton style={{ display: "none" }} ref={checkBtn} />
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <div className="" style={{ marginLeft: '15px' }}>
          <div>
            <b>
              <h5 className="mt-3 mb-3">{t("Receipt Setting")}</h5>
            </b>
          </div>
        </div>
        <div className="card" style={{ marginLeft: '15px' }}>
          <div className="row">
            <div className="col-md-12">
              <div className="card-body">
                <Form
                  role="form text-left"
                  onSubmit={handleSubmit(handleReceipt)}
                  ref={form}
                  action="."
                  method="POST"
                  id="addReceiptForm"
                >
                  {
                    <>
                      <div className="form-group row">
                        <div className="col-md-6"></div>
                      </div>
                      <label className="col-lg-12 col-form-label required">
                        {t("Receipt Number Starts From")}{" "}
                        <Tooltip content={t("StartingSeriesofReceipt_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <div className="col-lg-6">
                        <input
                          value={receiptseries}
                          placeholder={t("Ex. 10000")}
                          className="form-control no-spinner"
                          type="number"
                          onChange={(e) => setReceiptSeries(e.target.value)}
                          name="startingseriesofcontract"
                          id="startingseriesofcontract"
                        />
                      </div>
                      <div className="text-left py-3">
                        <button
                          type="submit"
                          className="btn-save border-0 btn btn-primary btn-gradient-primary btn-md"
                        >
                          {receiptloading === false ? (
                            t("Save")
                          ) : (
                            <ButtonLoading />
                          )}
                        </button>
                        &nbsp;&nbsp;
                      </div>
                    </>
                  }
                  <CheckButton style={{ display: "none" }} ref={checkBtn} />
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* <div className="">
        <div className="" style={{marginLeft:'15px'}}>
          <div>
            <b>
              <h5 className="mt-3 mb-3">{t("Tax  Setup")}</h5>
            </b>
          </div>
        </div>
        <div className="card" style={{marginLeft:'15px'}}>
          <div className="row">
            <div className="col-md-12">
              <div className="card-body">
                <Form
                  role="form text-left"
                  onSubmit={handleSubmit(handleTaxRateSetup)}
                  ref={form4}
                  action="."
                  method="POST"
                  
                >
                  {
                    <>
                      <div className="form-group row">
                        <div className="col-md-6"></div>
                      </div>
                      <label className="col-lg-12 col-form-label required">
                        {t("Tax Setup")}{" "}
                        <Tooltip content={t("TaxSetup_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
      
                      <div className="row">
                        <div
                          className="form-check"
                          style={{ width: "25%", paddingLeft: "2.73em" }}
                        >
                          <input
                            className="form-check-input"
                            value="Manual"
                            type="checkbox"
                            name="Manual"
                            id="flexRadioDefault1"
                            checked={taxrate_setup.includes("Manual")}
                            {...register("taxrate", {
                              onChange: (e, value) => {
                                TaxRateSetup(e);
                              },
                              required: false,
                            })}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault1"
                          >
                            Manual
                          </label>
                        </div>
                        <div
                          className="form-check"
                          style={{ width: "25%", paddingLeft: "3.0em" }}
                        >
                          <input
                            className="form-check-input"
                            value="Tax Rate Table"
                            type="checkbox"
                            name="Tax Rate Table"
                            id="flexRadioDefault2"
                            checked={taxrate_setup.includes("Tax Rate Table")}
                            {...register("taxrate", {
                              onChange: (e, value) => {
                                TaxRateSetup(e);
                              },
                              required: false,
                            })}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault2"
                          >
                            Tax Rate Table
                          </label>
                          </div>
                          </div>
                      <div className="text-left py-3">
                        <button
                          type="submit"
                          className="btn-save border-0 btn btn-primary btn-gradient-primary btn-lg"
                        >
                          {receiptloading === false ? (
                            t("Save")
                          ) : (
                            <ButtonLoading />
                          )}
                        </button>
                        &nbsp;&nbsp;
                      </div>
                    </>
                  }
                  <CheckButton style={{ display: "none" }} ref={checkBtn4} />
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default EditSetting;
